import axios from "../config";
import { API_VERSION } from "config";

export const createComment = (requestBody) =>
  axios.post(`${API_VERSION}/comment/createComment`, requestBody);
export const fetchComments = (requestBody) =>
  axios.post(`${API_VERSION}/comment/list`, {
    comments: { reference_id: requestBody }
  });
